import { forecastDataType } from "@/schemas/prevision-data-schema";
import i18n from "@/utils/i18n";

const days = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday",
];

const months = [
	"Jan.",
	"Feb.",
	"Mar.",
	"Apr.",
	"May.",
	"Jun.",
	"Jul.",
	"Aug.",
	"Sep.",
	"Oct.",
	"Nov.",
	"Dec.",
];

export const formatDatePrevisionTable = (dateString: string): string => {
	return (
		new Intl.DateTimeFormat("en-GB", {
			timeZone: "Asia/Kuwait",
			hour: "2-digit",
			hourCycle: "h23",
		}).format(new Date(dateString)) + ":00"
	);
};

export const getCurrentDateWithDay = (
	date: Date = new Date(),
): {
	day: string;
	date: string;
} => {
	return {
		day: i18n.t(days[date.getDay()]),
		date: `${String(date.getDate()).padStart(2, "0")}-${String(
			date.getMonth() + 1,
		).padStart(2, "0")}`,
	};
};

export const parseDayMonthToDate = (
	dayMonth: string,
	year: number = 2026,
): Date => {
	const [day, month] = dayMonth.split("-").map(Number);

	return new Date(year, month - 1, day);
};

export const formatCurrentDate = ({
	date = new Date(),
	lang,
}: {
	lang: "ar" | "en";
	date?: Date;
}): string => {
	const locale = lang === "ar" ? "ar-EG-u-nu-latn" : "en-GB";

	return new Intl.DateTimeFormat(locale, {
		day: "2-digit",
		month: "short",
		year: "numeric",
	}).format(date);
};

export const formatCurrentDayWithMonth = (date: Date | string): string => {
	const d = new Date(date);

	const day = d.getDate().toString().padStart(2, "0");
	const year = d.getFullYear();

	const month = months[d.getMonth()];

	return `${day} ${month} ${year}`;
};

export const getClosestPastDate = (date = new Date(), step = 3): Date => {
	const result = new Date(date);

	const hour = result.getHours();
	const closestHour = Math.floor(hour / step) * step;

	result.setHours(closestHour, 0, 0, 0);

	return result;
};

export const shouldDisableCarouselNextButton = (
	data?: forecastDataType[],
): number => {
	if (!data) return 1;

	const firstDate = new Date(data[0].timestep);
	const lastDate = new Date(data[data.length - 1].timestep);

	const diffInMs = lastDate.getTime() - firstDate.getTime();
	const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

	return diffInDays;
};

// return une string dans ce format: 11:50 06 SEP 2025
export const formatDateWeather = (date: Date): string => {
	const hours = date.getHours().toString().padStart(2, "0");
	const day = date.getDate().toString().padStart(2, "0");

	const month = months[date.getMonth()];
	const year = date.getFullYear();

	return `${hours}:00 ${day} ${month} ${year}`;
};

export const compareIosDate = (v1: Date, v2: Date): boolean => {
	return v1.toISOString().split("T")[0] === v2.toISOString().split("T")[0];
};

export const formatMarineDateChart = (timestep: string): string => {
	const date = new Date(timestep);

	const day = Number(
		new Intl.DateTimeFormat("en-GB", {
			timeZone: "Asia/Kuwait",
			day: "numeric",
		}).format(date),
	);

	const month = new Intl.DateTimeFormat("en-GB", {
		timeZone: "Asia/Kuwait",
		month: "short",
	}).format(date);

	const weekday = new Intl.DateTimeFormat("en-GB", {
		timeZone: "Asia/Kuwait",
		weekday: "short",
	}).format(date);

	const suffix =
		day > 3 && day < 21
			? "th"
			: ["th", "st", "nd", "rd"][Math.min(day % 10, 4)] || "th";

	return `${weekday}. ${day}${suffix} ${month}.`;
};
